export const cacheKeys = {
    CUSTOM_SECURITY: 'CUSTOM_SECURITY'
};

export const cacheActions = {
    PUT: 'PUT',
    GET: 'GET',
    EVICT: 'EVICT'
};
